import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaSmallBoldTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaSmallBoldText extends Component<KuikaSmallBoldTextProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-small--bold", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaSmallBoldText;
